import React from 'react';
import { Icon, Spin } from 'antd';
import classNames from 'classnames';

const STATUS_CONFIG = {
  loading: { icon: 'loading', spin: true },
  info: { icon: 'info-circle' },
  error: { icon: 'close-circle' },
  success: { icon: 'check-circle' },
};

export default function OnboardingStatusBanner({ type = 'info', title, description }) {
  const config = STATUS_CONFIG[type] || STATUS_CONFIG.info;

  return (
    <div
      className={classNames('onboarding-registration-status', `onboarding-registration-status-${type}`)}
      role="alert"
      aria-live="polite"
    >
      <span className="onboarding-registration-status-icon" aria-hidden>
        {config.spin ? <Spin /> : <Icon type={config.icon} />}
      </span>
      <div className="onboarding-registration-status-content">
        <strong>{title}</strong>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
}
